"use client";

import { WoozooFooterLogo } from "./WoozooLogo";
import { useI18n } from "@/i18n/context";

export function ContactSection() {
  const { t } = useI18n();

  return (
    <section
      id="contact"
      className="relative bg-bg-dark min-h-[899px] overflow-hidden"
    >
      {/* Title */}
      <p data-reveal className="font-jetbrains text-[18px] text-white text-center uppercase tracking-[1.26px] pt-[77px] leading-normal">
        {t.contact.title}
      </p>

      {/* Form */}
      <div data-reveal className="flex justify-center mt-[96px] px-8">
        <form className="w-[671px]" onSubmit={(e) => e.preventDefault()}>
          {/* Row 1: Name + Email */}
          <div className="flex gap-[13px] mb-[12px]">
            <input
              type="text"
              placeholder={t.contact.name.toUpperCase()}
              className="flex-1 h-[50px] bg-input-bg px-[20px] py-[8px] font-dm font-medium text-[15px] text-white uppercase tracking-[1.5px] placeholder:text-[#a9a9a9]"
              required
            />
            <input
              type="email"
              placeholder={t.contact.email.toUpperCase()}
              className="flex-1 h-[50px] bg-input-bg px-[20px] py-[8px] font-dm font-medium text-[15px] text-white uppercase tracking-[1.5px] placeholder:text-[#a9a9a9]"
              required
            />
          </div>

          {/* Row 2: Society */}
          <input
            type="text"
            placeholder={t.contact.society.toUpperCase()}
            className="w-full h-[50px] bg-input-bg px-[20px] py-[8px] font-dm font-medium text-[15px] text-white uppercase tracking-[1.5px] placeholder:text-[#a9a9a9] mb-[12px]"
            required
          />

          {/* Row 3: Message */}
          <textarea
            placeholder={t.contact.message.toUpperCase()}
            className="w-full h-[234px] bg-input-bg px-[20px] pt-[20px] pb-[8px] font-dm font-medium text-[15px] text-white uppercase tracking-[1.5px] placeholder:text-[#a9a9a9] resize-none"
          />
        </form>
      </div>

      {/* Footer links */}
      <div data-reveal className="flex justify-center gap-[13px] mt-[62px]">
        <a
          href="#"
          className="font-dm font-medium text-[15px] text-white uppercase tracking-[1.5px] hover:opacity-70 transition-opacity"
        >
          {t.contact.legals}
        </a>
        <a
          href="#"
          className="font-dm font-medium text-[15px] text-white uppercase tracking-[1.5px] hover:opacity-70 transition-opacity"
        >
          {t.contact.help}
        </a>
        <a
          href="https://instagram.com/woozoo"
          target="_blank"
          rel="noopener noreferrer"
          className="font-dm font-medium text-[15px] text-white uppercase tracking-[1.5px] hover:opacity-70 transition-opacity"
        >
          {t.contact.instagram}
        </a>
      </div>

      {/* Giant WOOZOO logo — scales up as you reach the bottom */}
      <div data-reveal="scale" className="absolute bottom-0 left-0 right-0 translate-y-[8%]">
        <WoozooFooterLogo className="w-full h-auto" />
      </div>
    </section>
  );
}
